export default __webpack_public_path__ + "static/media/image.85595128.jpg";